import React, { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Box,
  Chip,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Layout from '../components/Layout/Layout';
import apiService from '../services/api';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 300,
  },
}));

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#1a1a2e',
    color: '#fff',
    fontWeight: 600,
  },
}))(TableCell);

function Alerts() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [alerts, setAlerts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await apiService.getAlerts();
      setAlerts(data);
    } catch (error) {
      console.error('Error fetching alerts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleString('en-IN');
  };

  if (loading) {
    return (
      <Layout title="Alerts" onRefresh={fetchData}>
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout title="Alerts" onRefresh={fetchData}>
      <TableContainer component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell>Symbol</StyledTableCell>
              <StyledTableCell>Script</StyledTableCell>
              <StyledTableCell>Side</StyledTableCell>
              <StyledTableCell>LTP</StyledTableCell>
              <StyledTableCell>Catalog</StyledTableCell>
              <StyledTableCell>Source</StyledTableCell>
              <StyledTableCell>Created At</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alerts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((alert) => (
              <TableRow key={alert.id} hover>
                <TableCell>{alert.id}</TableCell>
                <TableCell>{alert.symbol}</TableCell>
                <TableCell>{alert.script_name}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={alert.side}
                    style={{
                      backgroundColor: String(alert.side).includes('1') ? '#e8f5e9' : '#ffebee',
                      color: String(alert.side).includes('1') ? '#2e7d32' : '#c62828',
                    }}
                  />
                </TableCell>
                <TableCell>{alert.ltp}</TableCell>
                <TableCell>{alert.catalog_name}</TableCell>
                <TableCell>{alert.source}</TableCell>
                <TableCell>{formatDate(alert.created_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 15, 25]}
          component="div"
          count={alerts.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={(e, p) => setPage(p)}
          onChangeRowsPerPage={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
        />
      </TableContainer>
    </Layout>
  );
}

export default Alerts;
